import type { SVGProps } from 'react'
const SvgSyAlarmclock = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={13} r={8} fillOpacity={0.24} />
		<path d="M5.5 4a.5.5 0 0 0-.354.146l-2 2a.5.5 0 0 0 0 .708.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0 0-.708A.5.5 0 0 0 5.5 4m12.646.146a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708 0 .5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.708 0M12 7.5a.5.5 0 0 0-.5.5v4.924a.75.75 0 0 0 .125.416l1.959 2.937a.5.5 0 0 0 .693.139.5.5 0 0 0 .139-.693L12.5 12.848V8a.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyAlarmclock
